module.exports = __webpack_public_path__ + "static/media/user.d0a56d83.gif";